const nuam = {
  FORMS: [
    {
      type: 'nuam-contact-form',
      name: 'NuamContactForm',
      message: {
        open: 'Formulario contacto',
        send: 'Envío Formulario De Contacto'
      }
    },
    {
      type: 'nuam-leads-form',
      name: 'NuamLeadsForm',
      message: {
        open: 'Formulario captación de leads',
        send: 'Envío Formulario De Captación De Leads'
      }
    },
    {
      type: 'bvc-contact-form',
      name: 'NuamContactForm',
      message: {
        open: 'Formulario contacto',
        send: 'Envío Formulario De Contacto'
      }
    },
    {
      type: 'bvl-contact-form',
      name: 'NuamContactForm',
      message: {
        open: 'Formulario contacto',
        send: 'Envío Formulario De Contacto'
      }
    },
    {
      type: 'bsx-contact-form',
      name: 'NuamContactForm',
      message: {
        open: 'Formulario contacto',
        send: 'Envío Formulario De Contacto'
      }
    }
  ],
  CSS: {
    id: '633449c2270996a119673c66',
    name: 'nuam',
    avatar: {
      name: 'nuam',
      header: 'https://chatbotqa.gatblac.com/static/avatar/nuam/nuam.svg',
      new: 'https://chatbotqa.gatblac.com/static/avatar/nuam/Avatar-1.svg',
      open: 'https://chatbotqa.gatblac.com/static/avatar/nuam/Avatar-1.svg',
      close: 'https://chatbotqa.gatblac.com/static/avatar/nuam/Avatar-1.svg'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#fd441e',
        borderColor: '#fd441e'
      }
    }
  }
}

export default nuam
